import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef, ref } from "vue";
import { RawLocation } from "vue-router";
import { BIconSearch, BFormInput } from "bootstrap-vue";
import useStore from "@/store/useStore";
import { useRoute, useRouter } from "vue-router/composables";

type Match = { name: string; type: string; route: RawLocation };

export default /*#__PURE__*/_defineComponent({
  __name: 'search',
  setup(__props) {

const searchString = ref("");
const arrowCounter = ref(-1);

const store = useStore();
const router = useRouter();
const route = useRoute();
const network = store.network;

const showSuggestions = computed(() => {
  if (searchString.value === "") {
    return false;
  }

  return filteredList.value.length !== 0;
});

const filteredList: ComputedRef<Match[]> = computed(() => {
  let match = (text: string) =>
    text.toLowerCase().includes(searchString.value.toLowerCase().trim());

  let matchedOrganizations = network.organizations
    .filter((organization) => {
      return match(organization.name);
    })
    .map((organization) => {
      return {
        name: organization.name,
        type: "organization",
        route: {
          name: "organization-dashboard",
          params: { organizationId: organization.id },
          query: {
            center: "1",
            "no-scroll": "1",
            view: route.query.view,
            network: route.query.network,
          },
        } as RawLocation,
      };
    });

  let matchedNodes = network.nodes
    .filter((node) => {
      return (
        match(node.displayName) || match(node.publicKey) || match(node.key)
      );
    })
    .map((node) => {
      return {
        name: node.displayName,
        type: node.isValidator ? "validator node" : "watcher node",
        route: {
          name: "node-dashboard",
          params: { publicKey: node.publicKey },
          query: {
            center: "1",
            "no-scroll": "1",
            view: route.query.view,
            network: route.query.network,
          },
        } as RawLocation,
      };
    });

  return matchedOrganizations.concat(matchedNodes).slice(0, 10);
});

function navigate(match: Match) {
  searchString.value = "";
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  router.push(match.route).catch(() => {});
}

function onArrowDown() {
  if (arrowCounter.value < filteredList.value.length - 1) {
    arrowCounter.value = arrowCounter.value + 1;
  } else arrowCounter.value = 0;
}

function onArrowUp() {
  if (arrowCounter.value > 0) {
    arrowCounter.value = arrowCounter.value - 1;
  } else arrowCounter.value = filteredList.value.length - 1;
}

function onEnter() {
  if (arrowCounter.value !== -1) {
    navigate(filteredList.value[arrowCounter.value]);
  }

  arrowCounter.value = -1;
}

return { __sfc: true,searchString, arrowCounter, store, router, route, network, showSuggestions, filteredList, navigate, onArrowDown, onArrowUp, onEnter, BIconSearch, BFormInput }
}

})